import ko from 'knockout';
import moment from 'moment';
import { customFetch as fetch } from '../fetch';

class NotifyCompanyRegistration {
    id: string;
    requestName: string;
    companyName: string;
    dateLabel: string;
    selected: KnockoutObservable<boolean>;

    constructor(data: any) {
        this.id = data.id;
        this.requestName = data.requestName;
        this.companyName = data.companyName;
        this.dateLabel = `${moment(data.startDate).format('DD-MM-YYYY HH:mm')} - ${moment(data.endDate).format('HH:mm')}`;
        this.selected = ko.observable(false);
    }
}

// Accepted future registrations of an employee, from which the admin selects the
// ones whose company should be mailed that the employee is removed from the request.
export class NotifyCompanyRegistrationsModel {
    loading: KnockoutObservable<boolean>;
    loadFailed: KnockoutObservable<boolean>;
    registrations: KnockoutObservableArray<NotifyCompanyRegistration>;
    hasRegistrations: KnockoutComputed<boolean>;
    allSelected: KnockoutComputed<boolean>;
    toggleSelectAllLabel: KnockoutComputed<string>;

    constructor(userId: string) {
        this.loading = ko.observable(true);
        this.loadFailed = ko.observable(false);
        this.registrations = ko.observableArray([]);
        this.hasRegistrations = ko.pureComputed(
            () => this.registrations().length > 0,
        );
        this.allSelected = ko.pureComputed(
            () =>
                this.hasRegistrations() &&
                this.registrations().every((r) => r.selected()),
        );
        this.toggleSelectAllLabel = ko.pureComputed(() =>
            this.allSelected() ? 'Deselecteer alles' : 'Selecteer alles',
        );

        this.load(userId);
    }

    async load(userId: string) {
        try {
            const response = await fetch(
                `/Admin/Employee/AcceptedFutureRegistrations/${userId}`,
            );

            if (response.ok) {
                this.registrations(
                    (response.data ?? []).map(
                        (r: any) => new NotifyCompanyRegistration(r),
                    ),
                );
            } else {
                this.loadFailed(true);
            }
        } catch {
            this.loadFailed(true);
        } finally {
            this.loading(false);
        }
    }

    toggleSelectAll() {
        const select = !this.allSelected();
        this.registrations().forEach((r) => r.selected(select));
    }

    selectedIds(): string[] {
        return this.registrations()
            .filter((r) => r.selected())
            .map((r) => r.id);
    }
}
